<template>
  <div
    class="modal fade"
    id="finishPreCheckin"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg modal-md modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-warning">
            {{ $t("touch-down.enter-pass") }}
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <!-- Form -->
        <form @submit.prevent="submit()">
          <!-- modal-body -->
          <div class="modal-body">
            <small class="form-text">
              {{ $t("touch-down.finished-pre-checkin-note") }}
            </small>

            <!-- Email input field -->
            <div class="form-group">
              <label>
                {{ $t("touch-down.email") }}
              </label>
              <input
                v-model="form.email"
                v-half-width
                type="email"
                class="form-control border-top-0 border-left-0 border-right-0"
                placeholder="abcd@xxxxxxx.com"
                required
              />
            </div>

            <!-- Pass input field -->
            <div class="form-group">
              <label>
                {{ $t("touch-down.pass") }}
              </label>
              <input
                v-model="form.pass"
                type="password"
                class="form-control border-top-0 border-left-0 border-right-0"
                :placeholder="$t('touch-down.enter-pass')"
                required
              />
            </div>

            <div
              class="alert alert-danger"
              role="alert"
              v-if="restrictionErrorMsg"
            >
              {{ restrictionErrorMsg }}
            </div>

            <div
              class="alert alert-danger"
              role="alert"
              v-for="(i, k) in invalid_code_error"
              :key="k"
            >
              {{ $t("touch-down.error_message") }}
            </div>
          </div>
          <!-- /.modal-body -->

          <!-- modal-footer -->
          <div class="modal-footer d-flex justify-content-center">
            <!-- Submit button -->
            <button type="submit" class="btn btn-primary rounded-pill">
              {{ $t("touch-down.confirm") }}
            </button>
          </div>
          <!-- modal-footer -->
        </form>
        <!-- /.Form -->
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import { booking_status } from "@/modules/checkin-facility/utils/mockup";

export default {
  name: "FinishPreCheckin",

  props: {
    facility: Object,
  },

  data() {
    return {
      form: {
        pass: "",
        email: "",
        mode: "pre-checkin",
      },
      invalid_code_error: [],
      restrictionErrorMsg: "",
    };
  },
  mounted() {
    // Auto confirm
    if (this.$route.query.e && this.$route.query.k) {
      this.form.email = this.$route.query.e;
      this.form.pass = this.$route.query.k;
      this.submit();
    }
  },
  methods: {
    async submit() {
      this.restrictionErrorMsg = "";
      this.form.facility_id = this.facility.id;

      const response = await this.$lionheart
        .post("/v2/facility-booking/list", this.form)
        .then((r) => r.data)
        .catch((error) => {
          console.log(error);
          return null;
        });

      if (!response || response.data.length === 0) {
        this.appendError();
        this.form.pass = "";
        this.form.email = "";
        return;
      }

      const booking = response.data[0];

      if (booking.booking_status_id != booking_status.pre_check_in) {
        this.$emit("is-loading", false);
        this.restrictionErrorMsg = this.$t('touch-down.not-precheckin');
        this.form.pass = "";
        this.form.email = "";
        return;
      }

      // Block here, inside this modal, before the guest ever sees the Reservation review screen —
      // same gate the final /checkin submission already enforces (touchdown-restriction-check).
      const restriction = await this.$lionheart
        .post("/checkin/touchdown-restriction-check", {
          facility_id: this.facility.id,
          pms_reservation_no: booking.pms_reservation_no,
          pass: booking.pass,
        })
        .then((r) => r.data)
        .catch(() => ({ isCheckinAvailable: true }));

      if (restriction.isCheckinAvailable === false) {
        this.$emit("is-loading", false);
        this.restrictionErrorMsg = restriction.reason === 'date'
          ? this.$t('visit-information-form.checkin_date_restricted_msg')
          : this.$t('visit-information-form.checkin_restricted_msg', {
              from: moment(restriction.from, "HH:mm").format("h:mm A"),
              to: moment(restriction.to, "HH:mm").format("h:mm A"),
            });
        this.form.pass = "";
        this.form.email = "";
        return;
      }

      this.$emit("load-booking-details", response);
      this.form.pass = "";
      this.form.email = "";
    },
    appendError() {
      this.$emit("is-loading", false);
      this.invalid_code_error.push(
        "We could not find a reservation with this email and pass. Please try again"
      );
      setTimeout(() => {
        this.invalid_code_error.shift();
      }, 5000);
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-title {
  text-align: center;
  width: 100%;
}

.form-text {
  display: block;
  margin-top: 0.25rem;
  margin-bottom: 20px;
  font-family: "Poppins";
  font-size: 14px;
  color: #4d4d4d;
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
  color: #4d4d4d;
}

$theme-colors: (
  "warning": #1a5dab,
  "primary": #1aa8de,
);
@import "~bootstrap/scss/bootstrap";
</style>